import { render, staticRenderFns } from "./MultipleCardItem.vue?vue&type=template&id=55237c4a&scoped=true&"
import script from "./MultipleCardItem.vue?vue&type=script&lang=js&"
export * from "./MultipleCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55237c4a",
  null
  
)

export default component.exports